export enum AiRecommendErrorType {
    QUOTA_EXCEEDED = "QUOTA_EXCEEDED",
    LOGIC_FAILURE = "LOGIC_FAILURE"
}
